module.exports = __webpack_public_path__ + "img/07.e3c8bdc5.jpg";